import { call, put } from 'redux-saga/effects';
import {
  getReceiptStatisticsAll,
  GetReceiptStatisticsResponse,
} from '../api';
import {
  fetchReceiptStatisticsAllFailure,
  fetchReceiptStatisticsAllSuccess,
} from '../actions';
import { FetchReceiptStatisticsAllRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { unwrapReceiptStatisticsPayload } from 'utils/receipt-statistics';

export function* fetchReceiptStatisticsAllSaga(
  action: FetchReceiptStatisticsAllRequestAction
) {
  try {
    const dateRange = action.payload ?? {};

    const response: GetReceiptStatisticsResponse = yield call(
      getReceiptStatisticsAll,
      dateRange
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    const statistics = unwrapReceiptStatisticsPayload(
      response?.data as Record<string, unknown>
    );
    if (!statistics) {
      throw new Error('Invalid receipt statistics response');
    }

    yield put(fetchReceiptStatisticsAllSuccess(statistics, dateRange));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchReceiptStatisticsAllFailure());
  }
}
